// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-ManageTB-Hotels-styles___paper--w_Cum {
  padding: 32px;
  max-width: 736px;
  margin: 0 auto 30px;
  margin-left: 0;
  width: 100%;
  padding-bottom: 20px;
}

.components-ManageTB-Hotels-styles___dropdown--Fr0Qv {
  padding: 15px;
  max-width: 736px;
}

.components-ManageTB-Hotels-styles___root--FUC8X {
  width: 100%;
}

.components-ManageTB-Hotels-styles___menuItem--CXsoq {
  font-size: 15px;
  color: #1b2432 !important;
  line-height: 18px;
}

.components-ManageTB-Hotels-styles___listItem--HTqny {
  height: auto !important;
  padding-top: 8px;
  padding-bottom: 8px;
}

.components-ManageTB-Hotels-styles___location--AxLNo {
  margin-bottom: 5px;
}

.components-ManageTB-Hotels-styles___inputContainer--zYUHr {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 32px;
}

.components-ManageTB-Hotels-styles___inputContainer--zYUHr.components-ManageTB-Hotels-styles___passportInfo--tPntW {
    padding-bottom: 24px;
  }

.components-ManageTB-Hotels-styles___inputContainer--zYUHr.components-ManageTB-Hotels-styles___inputContainerTravelerSelection--zXMV9 {
    padding: 16px 0 0;
    border-bottom: none;
    padding-top: 0;
  }

.components-ManageTB-Hotels-styles___inputContainer--zYUHr.components-ManageTB-Hotels-styles___inputContainerTravelerSelectionOpen--GLgV4 {
    padding: 0 0 32px 0;
  }

.components-ManageTB-Hotels-styles___inputContainer--zYUHr.components-ManageTB-Hotels-styles___wrapperContainer--WY19Q {
    border-top: 1px solid #dddee0;
    flex-direction: column;
    padding-top: 32px;
  }

.components-ManageTB-Hotels-styles___inputContainer--zYUHr.components-ManageTB-Hotels-styles___wrapperContainer--WY19Q .components-ManageTB-Hotels-styles___subtitle--EstFk {
      color: #6d717a;
      font-size: 15px;
      padding: 6px 0 16px;
    }

.components-ManageTB-Hotels-styles___inputContainer--zYUHr.components-ManageTB-Hotels-styles___wrapperContainer--WY19Q .components-ManageTB-Hotels-styles___radioGroupLabel--azRGP {
      font-weight: 400;
    }

.components-ManageTB-Hotels-styles___secondarySelectInput--zCeUG {
  display: flex;
  align-items: center;
}

.components-ManageTB-Hotels-styles___inputWrapper--_nIxf {
  flex: 49% 0 1;
  padding: 8px 0 0;
}

.components-ManageTB-Hotels-styles___inputInVisible--mRZaH {
  display: none;
}

.components-ManageTB-Hotels-styles___inputWrapper_department--DGVUQ {
  flex: 49% 0 1;
  padding: 8px 0 0;
}

.components-ManageTB-Hotels-styles___inputWrapper_department--DGVUQ div label {
    z-index: 0;
  }

.components-ManageTB-Hotels-styles___table--JKwXb {
  margin: 20px 0 0;
}

.components-ManageTB-Hotels-styles___tableHead--H2LbT {
  color: #1b2432 !important;
  font-weight: 500 !important;
  font-size: 15px !important;
}

.components-ManageTB-Hotels-styles___tableRow--ZIoDn {
  height: 68px !important;
}

.components-ManageTB-Hotels-styles___tableRow--ZIoDn:last-child .components-ManageTB-Hotels-styles___tableCell--SSSqj {
      border: none;
    }

.components-ManageTB-Hotels-styles___tableRow--ZIoDn.components-ManageTB-Hotels-styles___addNewTableRow--gsN9P {
    border-bottom: 1px solid rgba(224, 224, 224, 1);
  }

.components-ManageTB-Hotels-styles___tableCell--SSSqj {
  font-size: 15px !important;
  padding: 16px 25px 16px 0 !important;
  min-width: unset !important;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 400px;
}

.components-ManageTB-Hotels-styles___tableCell--SSSqj.components-ManageTB-Hotels-styles___removeCell--PTAMI {
    text-align: right;
    padding: 0 !important;
    width: 100px;
  }

.components-ManageTB-Hotels-styles___tableCell--SSSqj.components-ManageTB-Hotels-styles___removeCell--PTAMI button {
      padding-left: 0;
      padding-right: 0;
    }

.components-ManageTB-Hotels-styles___tableCell--SSSqj.components-ManageTB-Hotels-styles___removeCell--PTAMI .components-ManageTB-Hotels-styles___button_more--ay3Be {
      min-width: 10px;
    }

.components-ManageTB-Hotels-styles___tableCell--SSSqj.components-ManageTB-Hotels-styles___removeCell--PTAMI .components-ManageTB-Hotels-styles___button_more--ay3Be:hover {
      background-color: transparent !important;
    }

.components-ManageTB-Hotels-styles___tableCell--SSSqj.components-ManageTB-Hotels-styles___removeCell--PTAMI .components-ManageTB-Hotels-styles___menuList--inMvB {
      font-size: 15px;
      letter-spacing: 0;
    }

.components-ManageTB-Hotels-styles___tableCell--SSSqj.components-ManageTB-Hotels-styles___removeCell--PTAMI .components-ManageTB-Hotels-styles___menuList--inMvB li:first-child {
        font-size: 15px;
        color: #6d717a !important;
      }

.components-ManageTB-Hotels-styles___tableCell--SSSqj.components-ManageTB-Hotels-styles___removeCell--PTAMI .components-ManageTB-Hotels-styles___menuList--inMvB li:nth-child(3) {
        font-size: 15px;
        color: #fc3b60 !important;
      }

.components-ManageTB-Hotels-styles___tableCell--SSSqj.components-ManageTB-Hotels-styles___removeCell--PTAMI .components-ManageTB-Hotels-styles___menuList--inMvB svg {
        margin-right: 5px;
      }

.components-ManageTB-Hotels-styles___tableCell--SSSqj.components-ManageTB-Hotels-styles___inputTableCell--hGPy_ {
    padding: 16px 16px 16px 0 !important;
    width: 250px;
  }

.components-ManageTB-Hotels-styles___tableCell--SSSqj.components-ManageTB-Hotels-styles___inputTableCell--hGPy_ > div {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }

.components-ManageTB-Hotels-styles___tableCell--SSSqj.components-ManageTB-Hotels-styles___buttonTableCell--op4i_ {
    padding: 16px 0 !important;
    text-align: right;
    width: 160px;
  }

.components-ManageTB-Hotels-styles___alertMessageCont--UDIFN {
  display: flex;
  flex-direction: column;
}

.components-ManageTB-Hotels-styles___alertMessageCont--UDIFN .components-ManageTB-Hotels-styles___alertMessage--gOj1B {
    font-family: 'Roboto-Regular';
    font-size: 11px;
    color: #fc3b60 !important;
    letter-spacing: 0;
    margin-top: 4px;
  }

.components-ManageTB-Hotels-styles___emptyData--Fp1t0 {
  padding: 24px 0;
}

.components-ManageTB-Hotels-styles___selectWrapper--qEllr {
  width: 100%;
}

.components-ManageTB-Hotels-styles___cancel--ORHm8 {
  color: #6d717a;
  margin-right: 12px;
}

.components-ManageTB-Hotels-styles___addHotel--YksjC {
  display: flex;
  align-items: center;
  color: #1e8aff !important;
  font-size: 13px;
  padding: 6px 0 18px 24px;
  cursor: pointer;
}

.components-ManageTB-Hotels-styles___addHotel--YksjC:hover {
    color: #f6f6f7;
  }

.components-ManageTB-Hotels-styles___addHotel--YksjC {
  width: 100%;
  font-weight: 500;
}

.components-ManageTB-Hotels-styles___addIcon--MMaCW {
  height: 18px;
  margin-right: 5px;
}

.components-ManageTB-Hotels-styles___close--k3vSG {
  cursor: pointer;
  display: none;
}

.components-ManageTB-Hotels-styles___close--k3vSG .components-ManageTB-Hotels-styles___icon--aBbnt {
    color: rgba(0, 0, 0, 0.23);
    font-size: 16px;
    margin-right: 2px;
  }

.components-ManageTB-Hotels-styles___loaderContainer--TU1HU {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.2);
}

.components-ManageTB-Hotels-styles___iconAndInfoContainer--sN87g {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
}

.components-ManageTB-Hotels-styles___iconAndInfoContainer--sN87g .components-ManageTB-Hotels-styles___iconContainer--m0mBY {
    margin-right: 24px;
    margin-top: 4px;
  }

.components-ManageTB-Hotels-styles___iconAndInfoContainer--sN87g .components-ManageTB-Hotels-styles___iconContainer--m0mBY .components-ManageTB-Hotels-styles___icon--aBbnt {
      width: 32px;
      height: 32px;
    }

.components-ManageTB-Hotels-styles___iconAndInfoContainer--sN87g .components-ManageTB-Hotels-styles___titleStyle--tliGF {
    font-family: 'Roboto';
    font-weight: 500;
    font-size: 21px;
    color: #1b2432;
    letter-spacing: 0;
    margin-bottom: 7px;
    text-align: start;
  }

.components-ManageTB-Hotels-styles___iconAndInfoContainer--sN87g .components-ManageTB-Hotels-styles___subtitleStyle--AwQgf {
    font-family: 'Roboto';
    font-weight: 400;
    font-size: 13px;
    color: #6d717a;
    letter-spacing: 0;
  }

.components-ManageTB-Hotels-styles___buttonContainer--WbvIv {
  display: flex;
  justify-content: flex-end;
}

.components-ManageTB-Hotels-styles___userNameAndActionbuttonContaner--FmG_8 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.components-ManageTB-Hotels-styles___noBorder--QOvvC fieldset {
    border: none !important;
  }

.components-ManageTB-Hotels-styles___noBorder--QOvvC {
  margin: 0 !important;
}

.components-ManageTB-Hotels-styles___noBorder--QOvvC div {
    padding: 0 !important;
    padding-left: 1px !important;
    font-size: 17px;
    font-weight: 600;
  }

.components-ManageTB-Hotels-styles___popupButtonsContainer--SMN3M {
  border-top: 1px solid #e0e2e6;
  padding-top: 30px;
  display: flex;
  justify-content: flex-end;
}

.components-ManageTB-Hotels-styles___popupButtonsContainer--SMN3M button {
    width: 150px;
    height: 52px;
    font-size: 17px;
  }

.components-ManageTB-Hotels-styles___popupButtonsContainer--SMN3M button:first-child {
    border: 1px solid #318afb !important;
    border-radius: 6px;
    font-size: 17px;
    color: #318afb;
    letter-spacing: 0;
    text-align: center;
    margin-right: 15px;
  }

.components-ManageTB-Hotels-styles___popupButtonsContainer--SMN3M .components-ManageTB-Hotels-styles___cancelButton--e6DUx {
    border: 1px solid #318afb;
    border-radius: 6px;
    font-size: 17px;
    color: #318afb;
    letter-spacing: 0;
    text-align: center;
    margin-right: 15px;
  }

.components-ManageTB-Hotels-styles___addNewTableRowHotel--no2rf {
  margin-top: 20px;
}

.components-ManageTB-Hotels-styles___addHotelButtonLabel--gkCd1 {
  font-family: 'Roboto';
  font-size: 13px;
  color: #318afb;
  letter-spacing: 0;
  font-weight: 600;
}

.components-ManageTB-Hotels-styles___hotelTable--kNEms {
  margin-top: 10px;
}

.components-ManageTB-Hotels-styles___hotelTable--kNEms td {
    font-family: 'Roboto';
  }

.components-ManageTB-Hotels-styles___hotelTable--kNEms td:first-child {
    font-weight: 600;
  }

.components-ManageTB-Hotels-styles___item1--dxezN {
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./components/ManageTB/Hotels/styles.pcss","<no source>"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,oBAAoB;AA+BtB;;AA7BE;IACE,oBAAoB;EACtB;;AAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;EAChB;;AAEA;IACE,mBAAmB;EACrB;;AAEA;IACE,6BAA6B;IAC7B,sBAAsB;IACtB,iBAAiB;EAWnB;;AATE;MACE,cAAc;MACd,eAAe;MACf,mBAAmB;IACrB;;AAEA;MACE,gBAAgB;IAClB;;AAIJ;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AACA;EACE,aAAa;EACb,gBAAgB;AAKlB;;AAHE;IACE,UAAU;EACZ;;AAGF;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AAWzB;;AARI;MACE,YAAY;IACd;;AAGF;IACE,+CAA+C;EACjD;;AAGF;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAuDlB;;AArDE;IACE,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;EAiCd;;AA/BE;MACE,eAAe;MACf,gBAAgB;IAClB;;AAEA;MACE,eAAe;IACjB;;AAEA;MACE,wCAAwC;IAC1C;;AAEA;MACE,eAAe;MACf,iBAAiB;IAenB;;AAbE;QACE,eAAe;QACf,yBAAyB;MAC3B;;AAEA;QACE,eAAe;QACf,yBAAyB;MAC3B;;AAEA;QACE,iBAAiB;MACnB;;AAIJ;IACE,oCAAoC;IACpC,YAAY;EAMd;;AAJE;MACE,wBAAwB;MACxB,2BAA2B;IAC7B;;AAGF;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,YAAY;EACd;;AAEF;EACE,aAAa;EACb,sBAAsB;AASxB;;AAPE;IACE,6BAA6B;IAC7B,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;EACjB;;AAGF;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,wBAAwB;EACxB,eAAe;AAMjB;;AALE;IACE,cAAc;EAChB;;ACtNF;EDuNE,WAAW;EACX;CCxNF;;AD2NA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;AAOf;;AALE;IACE,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;EACnB;;AAGF;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,8BAA8B;AA4BhC;;AA1BE;IACE,kBAAkB;IAClB,eAAe;EAMjB;;AAJE;MACE,WAAW;MACX,YAAY;IACd;;AAGF;IACE,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB;;AACA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;AAGF;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAGE;IACE,uBAAuB;EACzB;;ACtSF;EDuSE;CCvSF;;ADySE;IACE,qBAAqB;IACrB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;EAClB;;AAGF;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;EACb,yBAAyB;AA0B3B;;AAzBE;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;AAEA;IACE,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;AAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;AAGF;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAOlB;;AANE;IACE,qBAAqB;EACvB;;AACA;IACE,gBAAgB;EAClB;;AAGF;EACE,aAAa;AACf","sourcesContent":[".paper {\n  padding: 32px;\n  max-width: 736px;\n  margin: 0 auto 30px;\n  margin-left: 0;\n  width: 100%;\n  padding-bottom: 20px;\n}\n\n.dropdown {\n  padding: 15px;\n  max-width: 736px;\n}\n\n.root {\n  width: 100%;\n}\n\n.menuItem {\n  font-size: 15px;\n  color: #1b2432 !important;\n  line-height: 18px;\n}\n\n.listItem {\n  height: auto !important;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.location {\n  margin-bottom: 5px;\n}\n\n.inputContainer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding-bottom: 32px;\n\n  &.passportInfo {\n    padding-bottom: 24px;\n  }\n\n  &.inputContainerTravelerSelection {\n    padding: 16px 0 0;\n    border-bottom: none;\n    padding-top: 0;\n  }\n\n  &.inputContainerTravelerSelectionOpen {\n    padding: 0 0 32px 0;\n  }\n\n  &.wrapperContainer {\n    border-top: 1px solid #dddee0;\n    flex-direction: column;\n    padding-top: 32px;\n\n    .subtitle {\n      color: #6d717a;\n      font-size: 15px;\n      padding: 6px 0 16px;\n    }\n\n    .radioGroupLabel {\n      font-weight: 400;\n    }\n  }\n}\n\n.secondarySelectInput {\n  display: flex;\n  align-items: center;\n}\n\n.inputWrapper {\n  flex: 49% 0 1;\n  padding: 8px 0 0;\n}\n\n.inputInVisible {\n  display: none;\n}\n.inputWrapper_department {\n  flex: 49% 0 1;\n  padding: 8px 0 0;\n\n  div label {\n    z-index: 0;\n  }\n}\n\n.table {\n  margin: 20px 0 0;\n}\n\n.tableHead {\n  color: #1b2432 !important;\n  font-weight: 500 !important;\n  font-size: 15px !important;\n}\n\n.tableRow {\n  height: 68px !important;\n\n  &:last-child {\n    .tableCell {\n      border: none;\n    }\n  }\n\n  &.addNewTableRow {\n    border-bottom: 1px solid rgba(224, 224, 224, 1);\n  }\n}\n\n.tableCell {\n  font-size: 15px !important;\n  padding: 16px 25px 16px 0 !important;\n  min-width: unset !important;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 400px;\n  \n  &.removeCell {\n    text-align: right;\n    padding: 0 !important;\n    width: 100px;\n\n    button {\n      padding-left: 0;\n      padding-right: 0;\n    }\n\n    .button_more {\n      min-width: 10px;\n    }\n\n    .button_more:hover {\n      background-color: transparent !important;\n    }\n\n    .menuList {\n      font-size: 15px;\n      letter-spacing: 0;\n\n      li:first-child {\n        font-size: 15px;\n        color: #6d717a !important;\n      }\n\n      li:nth-child(3) {\n        font-size: 15px;\n        color: #fc3b60 !important;\n      }\n\n      svg {\n        margin-right: 5px;\n      }\n    }\n  }\n\n  &.inputTableCell {\n    padding: 16px 16px 16px 0 !important;\n    width: 250px;\n\n    > div {\n      margin-top: 0 !important;\n      margin-bottom: 0 !important;\n    }\n  }\n\n  &.buttonTableCell {\n    padding: 16px 0 !important;\n    text-align: right;\n    width: 160px;\n  }\n}\n.alertMessageCont {\n  display: flex;\n  flex-direction: column;\n\n  .alertMessage {\n    font-family: 'Roboto-Regular';\n    font-size: 11px;\n    color: #fc3b60 !important;\n    letter-spacing: 0;\n    margin-top: 4px;\n  }\n}\n\n.emptyData {\n  padding: 24px 0;\n}\n\n.selectWrapper {\n  width: 100%;\n}\n\n.cancel {\n  color: #6d717a;\n  margin-right: 12px;\n}\n\n.addHotel {\n  display: flex;\n  align-items: center;\n  color: #1e8aff !important;\n  font-size: 13px;\n  padding: 6px 0 18px 24px;\n  cursor: pointer;\n  &:hover {\n    color: #f6f6f7;\n  }\n  width: 100%;\n  font-weight: 500;\n}\n\n.addIcon {\n  height: 18px;\n  margin-right: 5px;\n}\n\n.close {\n  cursor: pointer;\n  display: none;\n\n  .icon {\n    color: rgba(0, 0, 0, 0.23);\n    font-size: 16px;\n    margin-right: 2px;\n  }\n}\n\n.loaderContainer {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.iconAndInfoContainer {\n  display: flex;\n  align-items: stretch;\n  justify-content: space-between;\n\n  .iconContainer {\n    margin-right: 24px;\n    margin-top: 4px;\n\n    .icon {\n      width: 32px;\n      height: 32px;\n    }\n  }\n\n  .titleStyle {\n    font-family: 'Roboto';\n    font-weight: 500;\n    font-size: 21px;\n    color: #1b2432;\n    letter-spacing: 0;\n    margin-bottom: 7px;\n    text-align: start;\n  }\n  .subtitleStyle {\n    font-family: 'Roboto';\n    font-weight: 400;\n    font-size: 13px;\n    color: #6d717a;\n    letter-spacing: 0;\n  }\n}\n\n.buttonContainer {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.userNameAndActionbuttonContaner {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.noBorder {\n  fieldset {\n    border: none !important;\n  }\n  margin: 0 !important;\n\n  div {\n    padding: 0 !important;\n    padding-left: 1px !important;\n    font-size: 17px;\n    font-weight: 600;\n  }\n}\n\n.popupButtonsContainer {\n  border-top: 1px solid #e0e2e6;\n  padding-top: 30px;\n  display: flex;\n  justify-content: flex-end;\n  button {\n    width: 150px;\n    height: 52px;\n    font-size: 17px;\n  }\n\n  button:first-child {\n    border: 1px solid #318afb !important;\n    border-radius: 6px;\n    font-size: 17px;\n    color: #318afb;\n    letter-spacing: 0;\n    text-align: center;\n    margin-right: 15px;\n  }\n\n  .cancelButton {\n    border: 1px solid #318afb;\n    border-radius: 6px;\n    font-size: 17px;\n    color: #318afb;\n    letter-spacing: 0;\n    text-align: center;\n    margin-right: 15px;\n  }\n}\n\n.addNewTableRowHotel {\n  margin-top: 20px;\n}\n\n.addHotelButtonLabel {\n  font-family: 'Roboto';\n  font-size: 13px;\n  color: #318afb;\n  letter-spacing: 0;\n  font-weight: 600;\n}\n\n.hotelTable {\n  margin-top: 10px;\n  td {\n    font-family: 'Roboto';\n  }\n  td:first-child {\n    font-weight: 600;\n  }\n}\n\n.item1 {\n  display: flex;\n}\n",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `components-ManageTB-Hotels-styles___paper--w_Cum`,
	"dropdown": `components-ManageTB-Hotels-styles___dropdown--Fr0Qv`,
	"root": `components-ManageTB-Hotels-styles___root--FUC8X`,
	"menuItem": `components-ManageTB-Hotels-styles___menuItem--CXsoq`,
	"listItem": `components-ManageTB-Hotels-styles___listItem--HTqny`,
	"location": `components-ManageTB-Hotels-styles___location--AxLNo`,
	"inputContainer": `components-ManageTB-Hotels-styles___inputContainer--zYUHr`,
	"passportInfo": `components-ManageTB-Hotels-styles___passportInfo--tPntW`,
	"inputContainerTravelerSelection": `components-ManageTB-Hotels-styles___inputContainerTravelerSelection--zXMV9`,
	"inputContainerTravelerSelectionOpen": `components-ManageTB-Hotels-styles___inputContainerTravelerSelectionOpen--GLgV4`,
	"wrapperContainer": `components-ManageTB-Hotels-styles___wrapperContainer--WY19Q`,
	"subtitle": `components-ManageTB-Hotels-styles___subtitle--EstFk`,
	"radioGroupLabel": `components-ManageTB-Hotels-styles___radioGroupLabel--azRGP`,
	"secondarySelectInput": `components-ManageTB-Hotels-styles___secondarySelectInput--zCeUG`,
	"inputWrapper": `components-ManageTB-Hotels-styles___inputWrapper--_nIxf`,
	"inputInVisible": `components-ManageTB-Hotels-styles___inputInVisible--mRZaH`,
	"inputWrapperDepartment": `components-ManageTB-Hotels-styles___inputWrapper_department--DGVUQ`,
	"table": `components-ManageTB-Hotels-styles___table--JKwXb`,
	"tableHead": `components-ManageTB-Hotels-styles___tableHead--H2LbT`,
	"tableRow": `components-ManageTB-Hotels-styles___tableRow--ZIoDn`,
	"tableCell": `components-ManageTB-Hotels-styles___tableCell--SSSqj`,
	"addNewTableRow": `components-ManageTB-Hotels-styles___addNewTableRow--gsN9P`,
	"removeCell": `components-ManageTB-Hotels-styles___removeCell--PTAMI`,
	"buttonMore": `components-ManageTB-Hotels-styles___button_more--ay3Be`,
	"menuList": `components-ManageTB-Hotels-styles___menuList--inMvB`,
	"inputTableCell": `components-ManageTB-Hotels-styles___inputTableCell--hGPy_`,
	"buttonTableCell": `components-ManageTB-Hotels-styles___buttonTableCell--op4i_`,
	"alertMessageCont": `components-ManageTB-Hotels-styles___alertMessageCont--UDIFN`,
	"alertMessage": `components-ManageTB-Hotels-styles___alertMessage--gOj1B`,
	"emptyData": `components-ManageTB-Hotels-styles___emptyData--Fp1t0`,
	"selectWrapper": `components-ManageTB-Hotels-styles___selectWrapper--qEllr`,
	"cancel": `components-ManageTB-Hotels-styles___cancel--ORHm8`,
	"addHotel": `components-ManageTB-Hotels-styles___addHotel--YksjC`,
	"addIcon": `components-ManageTB-Hotels-styles___addIcon--MMaCW`,
	"close": `components-ManageTB-Hotels-styles___close--k3vSG`,
	"icon": `components-ManageTB-Hotels-styles___icon--aBbnt`,
	"loaderContainer": `components-ManageTB-Hotels-styles___loaderContainer--TU1HU`,
	"iconAndInfoContainer": `components-ManageTB-Hotels-styles___iconAndInfoContainer--sN87g`,
	"iconContainer": `components-ManageTB-Hotels-styles___iconContainer--m0mBY`,
	"titleStyle": `components-ManageTB-Hotels-styles___titleStyle--tliGF`,
	"subtitleStyle": `components-ManageTB-Hotels-styles___subtitleStyle--AwQgf`,
	"buttonContainer": `components-ManageTB-Hotels-styles___buttonContainer--WbvIv`,
	"userNameAndActionbuttonContaner": `components-ManageTB-Hotels-styles___userNameAndActionbuttonContaner--FmG_8`,
	"noBorder": `components-ManageTB-Hotels-styles___noBorder--QOvvC`,
	"popupButtonsContainer": `components-ManageTB-Hotels-styles___popupButtonsContainer--SMN3M`,
	"cancelButton": `components-ManageTB-Hotels-styles___cancelButton--e6DUx`,
	"addNewTableRowHotel": `components-ManageTB-Hotels-styles___addNewTableRowHotel--no2rf`,
	"addHotelButtonLabel": `components-ManageTB-Hotels-styles___addHotelButtonLabel--gkCd1`,
	"hotelTable": `components-ManageTB-Hotels-styles___hotelTable--kNEms`,
	"item1": `components-ManageTB-Hotels-styles___item1--dxezN`
};
module.exports = ___CSS_LOADER_EXPORT___;
